module.exports = __webpack_public_path__ + "img/fullscreen-exit.d7659268.svg";